const state = {
  partner: [],
  partnerToken: null,
  partnerTokenTime: null,
  sendForm: [],
};

export default state;
